/**
 *
 */
function product_list_item( e, settings ) {
    let price = Shopify.formatMoney(e.price),
        compare_at_price = Shopify.formatMoney(e.compare_at_price),
        html = '',
        reviews = (settings.reviews_template) ? settings.reviews_template.replace(/\$\{ID\}/ig, e.id): null;

    html += `<li class="grid-products-item  col-4">
    <h3 class="hide">${e.title}</h3>
    <a href="${e.url}" class="grid-product-link">
		<div class="responsive-image__wrapper background-image" style="background : url(${e.image})">
            
        </div>
        <p class="grid-product-title">${e.title}</p>`;

    if (settings.show_price === true) {
        html += `<div class="prices-wrapper">`;

        if (settings.reviews_template)
            html += `<div class="reviews">${reviews}</div>`;

        if (compare_at_price.replace(/[^1-9]|0/g,'') !== '')
            html += `<span class="compare-price">${compare_at_price}</span>`;

        html += `<span class="price">${price}</span></div>`;
    }

    html += `</a>
    </li>`;

    return html;
}

/**
 *
 */
function show_recently_viewed_products( e , settings ) {
    if (window.location.pathname.indexOf(e.url) < 0) {
        $('#recently-viewed-products').prepend(product_list_item(e, settings));
        $('#recently-viewed-products').siblings().show();
    }
}

/**
 *
 */
function cart_line(prod) {
    var variant_title = '';

    if(prod.variant_title != null){
         variant_title = prod.variant_title;
    }

    prod.image = image_resize(prod.image, 100, 100);

    return '<li class="cart-product" id="jq-cart-item-' + prod.id + '">' +
        '<div class="cart-product-image-wrapper">' +
        '<img src="' + prod.image + '" class="" alt=""/>' +
        ' </div>' +

        ' <div class="cart-product-wrapper">' +
        '<div class="product-info">' +
        '<p class="title-item-cart">' + prod.product_title + '</p>' +
        '<small class="product-variant">'+ variant_title +'</small>'+

        '<div class="cart-product-btn-wrapper">' +
        '<form action="/cart" class="jq-qtd-item-cart">' +
        '<button class="btn icon-minus btn-minus jq-minus-cart-item" name=' + prod.id + ' ></button>' +
        '<input class="jq-input-qtd-' + prod.id + ' input-qtd" name="updates[' + prod.id + ']" value="' + prod.quantity + '">' +
        '<button class="btn icon-plus btn-plus jq-plus-cart-item" name=' + prod.id + '  ></button>' +
        ' </form>' +
        ' </div>' +
        ' </div>' +

        ' <div class="product-price">' +
        '   <strong class="price" id="jq-cart-item-price-' + prod.id + '">' + Shopify.formatMoney(prod.final_line_price) + '</strong>' +
        '   <form action="/cart" class="jq-remove-cart-item">' +
        '     <input type="hidden" name="updates[' + prod.id + ']" value="0" class="jq-cart-item"/>' +
        '     <button class="bt-remove-cart" name=' + prod.id + '>Remove</button>' +
        '   </form>' +
        ' </div>' +
        ' </div>' +
        ' </li>';
}


function image_resize(image, x, y) {
    let size = '_' + x + 'x' + y;
    let img;
    let ext;

    img = image.replace(/_([0-9])*x([0-9])*\./g, '.').split('.');

    ext = img[img.length - 1];
    ext = size + '.' + ext;

    img = img.slice(0, img.length-1).join('.');

    return img + ext;
}

/**
 *
 */
function render_cart_drawer(cart, target) {
    target.html('');

    cart.items.forEach(function( prod ){
        target.prepend( cart_line( prod ) );
    });

    if (cart.item_count > 0) {
        $('.drawer-title').html(drawer_texts.not_empty_cart);
        $('.cart-container').removeClass('empty');
        $('.jq-total-price').html(Shopify.formatMoney(cart.total_price));
    }

    update_btn_add( cart.item_count );
}

/**
 *
 */
function prepare_data( form, cart_items ) {
    let id, quantity,
        data = {},
        form_data = form.serializeArray();

    form_data.forEach(function(e){
        if (e.name === 'id') {
            id = e.value;
        } else if (e.name === 'quantity') {
            quantity = parseInt(e.value);
            data[id] = get_product_quantity(cart_items, id) + quantity;
        } else if (e.name.indexOf('updates[') > -1) {
            data[e.name.replace(/[^0-9]/g, '')] = e.value;
        }
    });

    return { updates: data };
}

function get_product_quantity( items, product_id ) {
    for (var i = 0, j = items.length; (i < j) && (items[i].id != product_id); i++);

    return (i < j) ? parseInt(items[i].quantity) : 0;
}

/**
 *
 */
function update_btn_add( item_count ) {
    $('#cart-count > .count').html( item_count );

    if ( item_count > 1)
        $('.jq_qtd_bt_proceed').html( item_count + ' Items');
    else
        $('.jq_qtd_bt_proceed').html( item_count + ' Item');
}

/**
 *
 */
function update_shipping_bar( current_total_price,quantity_cart ){
    var semana = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var d = new Date();
    var type_of_value;

    if(quantity_cart == 0){
        if(shipping_bar.price_enable == "shipping_bar_free_price"){
            type_of_value = shipping_bar.first_free_shipping_text + '&nbsp<span class="free_shipping money" > '+ Shopify.formatMoney(shipping_bar.shipping_value)+'</span>&nbsp' + shipping_bar.second_free_shipping_text;
        } else{
            type_of_value = shipping_bar.first_free_shipping_text + '&nbsp<span class="free_shipping money" > ' + shipping_bar.shipping_quantity + ' Products</span>';
        }
        $('.shipping-bar-text').html(type_of_value );
    }else{
        if(shipping_bar.price_enable == "shipping_bar_free_price"){
            if(current_total_price == 0 ){
                $('.shipping-bar-text').html('ONLY <span class="free_shipping money" > ' + (Shopify.formatMoney(shipping_bar.shipping_value - current_total_price)) +'</span> AWAY FROM FREE SHIPPING!');
                $('.btn-wrapper form .text_botom_button').html("<strong>" + shipping_bar.text_cart_above_button_sucess + "</strong>");
            }
            else if(current_total_price >= shipping_bar.shipping_value ){
                $('.shipping-bar-text').html(shipping_bar.free_shipping_text );
                $('.btn-wrapper form .text_botom_button').html("<strong>" + shipping_bar.text_cart_above_button_sucess + "</strong>");
            }else{
                $('.shipping-bar-text').html('ONLY <span class="free_shipping money" > ' + (Shopify.formatMoney(shipping_bar.shipping_value - current_total_price)) +'</span> AWAY FROM FREE SHIPPING!');
                $('.btn-wrapper form .text_botom_button').html(shipping_bar.text_cart_above_button + '<br><strong>'+semana[d.getDay()] + ' Only!</strong>');
            }
        } else if(shipping_bar.price_enable == "shipping_bar_free_qtd") {
            if(quantity_cart == 0 ){
                $('.shipping-bar-text').html(shipping_bar.first_free_shipping_text + '&nbsp<span class="free_shipping money" > ' + (shipping_bar.shipping_quantity - quantity_cart) +'&nbspProducts </span> &nbsp' +shipping_bar.second_free_shipping_text);
                $('.btn-wrapper form .text_botom_button').html("<strong>" + shipping_bar.text_cart_above_button_sucess + "</strong>");
            }else if(quantity_cart >= shipping_bar.shipping_quantity ){
                $('.shipping-bar-text').html(shipping_bar.free_shipping_text );
                $('.btn-wrapper form .text_botom_button').html("<strong>" + shipping_bar.text_cart_above_button_sucess + "</strong>");
            }else{
                $('.shipping-bar-text').html('ONLY <span class="free_shipping money" > ' + (shipping_bar.shipping_quantity - quantity_cart) +'&nbspProducts </span> AWAY FROM FREE SHIPPING!');
                $('.btn-wrapper form .text_botom_button').html(shipping_bar.text_cart_above_button + '<br><strong>'+semana[d.getDay()] + ' Only!</strong>');
            }
        }
    }
}
